'use client';

import { forwardRef, useState, useCallback } from 'react';
import Input, { InputProps } from '../Input/Input';
import styles from './PasswordInput.module.css';

export interface PasswordInputProps extends Omit<InputProps, 'type' | 'rightIcon'> {}

const EyeIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
        <circle cx="12" cy="12" r="3" />
    </svg>
);

const EyeOffIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
        <line x1="1" y1="1" x2="23" y2="23" />
        <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
    </svg>
);

const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
    (props, ref) => {
        const [visible, setVisible] = useState(false);

        const toggleVisibility = useCallback(() => {
            setVisible(v => !v);
        }, []);

        return (
            <Input
                ref={ref}
                {...props}
                type={visible ? 'text' : 'password'}
                rightIcon={
                    <button type="button" className={styles.eyeButton} onClick={toggleVisibility} tabIndex={-1}>
                        {visible ? <EyeOffIcon /> : <EyeIcon />}
                    </button>
                }
            />
        );
    }
);

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
